import React from 'react';
import TextInput from 'components/v2/Input/TextInput';
import { useIMask } from 'react-imask';

export type MaskedProps<Value = string> = {
  mask: string;
  name?: string;
  label?: string;
  value?: string;
  error?: string;
  variant?: 'outlined' | 'filled' | 'standard';
  placeholderChar?: string;
  fullWidth?: boolean;
  onChange?: (event: any, value: Value) => void;
  onComplete?: (value: Value, maskRef: any, event?: any) => void;
};

const MaskedField: React.FC<MaskedProps> = (props) => {
  const {
    mask,
    name,
    value,
    onChange,
    onComplete,
    error,
    fullWidth,
    placeholderChar = 'X',
  } = props;

  const { ref } = useIMask(
    {
      mask,
      lazy: false,
      placeholderChar,
    },
    {
      onAccept: (value: string, ref: any, event: any) => {
        onChange && onChange(event, value);
      },
      onComplete,
      defaultUnmaskedValue: value,
    },
  );

  return (
    <TextInput name={name} ref={ref} error={error} fullWidth={fullWidth} />
  );
};

export default MaskedField;
